export const environment = {
  production: true,
  baseUrl: 'https://weget-api-production.kodius.com/',
  esUrl: 'https://elastic.wegetmusic.com',
  radioUrl: 'https://weget-radio.kodius.com/',
  socketUrl: 'https://wegetmusic.com/',
  shareUrl: 'https://wegetmusic.com/'
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts